<template>
  <div class="container max-w-lg mt-12">
    <div class="profile flex justify-between items-baseline border-b pb-4">
      <h2>
        {{ users.length }} Users
        <small
          v-if="isFiltered"
          class="text-xs inline-block bg-primary-200 text-primary-900 font-normal italic px-2 align-text-top"
        >
          Filtered: {{ filteredUsers.length }}
        </small>
      </h2>
      <input
        v-model="filter"
        placeholder="Search Users"
        type="search"
        class="px-4 py-2 bg-transparent focus:bg-white outline-none transition-all transition-normal"
      />
    </div>
    <ul
      v-if="totalUsers > 0"
      class="list-reset"
    >
      <li
        v-for="user in filteredUsers"
        :key="user.id"
        class="flex border-b pb-4 pt-4"
      >
        <div>
          <p>
            <a
              :href="route('users.view', user.id)"
              class="font-bold"
            >{{
              user.name
            }}</a>
            <span
              v-if="!user.email_verified_at"
              class="italic text-negative-500 text-xs"
            >
              Unverified
            </span>
          </p>
          <p>
            <app-badge 
              v-if="user.access_level === 'admin'"
              type="secondary"
              class="mr-2"
            >
              Admin
            </app-badge>
            <small>{{ user.company.name | sentencecase }}</small>
          </p>
        </div>
      </li>
    </ul>
    <div
      v-else
      class="flex h-64 items-center justify-center flex-col"
    >
      <icon
        icon="important"
        class="w-24 h-24 icons-primary"
      />
      <template v-if="isFiltered">
        <h3>No Results Found</h3>
      </template>
      <template v-else>
        <h3>There are no users available</h3>
      </template>
    </div>
    <div
      v-if="totalUsers > 0"
      class="flex mt-4 justify-center items-center"
    >
      <div class="w-32">
        <icon-link
          v-if="!firstPage"
          icon="cheveron-left-circle"
          href="#"
          @click.prevent="prevPage"
        >
          Previous
        </icon-link>
      </div>
      <div class="text-center px-4 text-sm font-bold w-32">
        {{ pageNumber }}/{{ totalPages }}
      </div>
      <div class="w-32 text-right">
        <icon-link
          v-if="!lastPage"
          icon="cheveron-right-circle"
          icon-placement="right"
          href="#"
          @click.prevent="nextPage"
        >
          Next
        </icon-link>
      </div>
    </div>
  </div>
</template>

<script>
import Fuse from "fuse.js";
export default {
  name: 'UserCompany',
  data() {
    return {
      pageNumber: 1,
      paginationAmount: 8,
      filter: ""
    };
  },
  computed: {
    users() {
      return this.state.users;
    },
    isFiltered() {
      return this.filter !== "" && this.filter !== null;
    },
    filteredUsers() {
      const end = this.paginationAmount * this.pageNumber;
      const start = end - this.paginationAmount;
      if (!this.isFiltered) return this.users.slice(start, end);
      return this.searchResults.slice(start, end);
    },
    searchResults() {
      const options = {
        shouldSort: true,
        tokenize: true,
        threshold: 0.4,
        location: 0,
        distance: 5,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["name", "email", 'access_level']
      };
      const results = new Fuse(this.users, options);
      return results.search(this.filter);
    },
    firstPage() {
      return this.pageNumber === 1;
    },
    lastPage() {
      return this.pageNumber === this.totalPages;
    },
    totalPages() {
      return Math.ceil(this.totalUsers / this.paginationAmount);
    },
    totalUsers() {
      return this.isFiltered ? this.filteredUsers.length : this.users.length;
    }
  },
  created() {
    document.title = `Company Users :: ${document.title}`;
  },
  methods: {
    prevPage() {
      if (this.firstPage) return;
      return this.pageNumber--;
    },
    nextPage() {
      if (this.lastPage) return;
      return this.pageNumber++;
    }
  }
}
</script>